import axios from "axios";

import {
  GET_EldSub,
  RESET_EldSub,
  LOADING
} from "../actionTypes";
import { DEV_EMS_APIS_URL, AWS_SERVER_APIS} from "configurations";
import { adminTokenDev, adminToken} from "../../helper";

const { SET_TRUE, SET_FALSE } = LOADING;

export const get = (elder_id) => {
  return dispatch => {
    dispatch({ type: SET_TRUE });

    adminToken()
      .then(token =>
        axios.get(
          `${AWS_SERVER_APIS}/elder-subscriptions?elder_id=${elder_id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`
            }
          }
        )
      )
      .then(res => {
        dispatch({ type: GET_EldSub, payload: res.data.data });
      })
      .catch(err => console.log(err))
      .finally(_ => dispatch({ type: SET_FALSE }));
  };
};

export const add = ({ name = ""}) => {
  return dispatch => {
    dispatch({ type: SET_TRUE });

    adminTokenDev()
      .then(token =>
        axios.post(
          `${DEV_EMS_APIS_URL}/elder-subscriptions`,
          {
            "channel_name": `${name}`
          },
          {
            headers: {
              Authorization: `Bearer ${token}`
            }
          }
        )
      )
      .then(res => {
        dispatch(get());
      })
      .catch(err => console.log(err))
      .finally(_ => dispatch({ type: SET_FALSE }));
  };
};

export const update = ({ id = "", name = "" }) => {
  return dispatch => {
    dispatch({ type: SET_TRUE });

    adminTokenDev()
      .then(token =>
        axios.put(
          `${DEV_EMS_APIS_URL}/elder-subscriptions`,
          {
            "id":id,
            "channel_name": `${name}`
        },
          
          {
            headers: {
              Authorization: `Bearer ${token}`
            }
          }
        )
      )
      .then(res => {
        dispatch(get());
      })
      .catch(err => console.log(err))
      .finally(_ => dispatch({ type: SET_FALSE }));
  };
};

export const deletedata = ({ id = ""}) => {
  return dispatch => {
    dispatch({ type: SET_TRUE });

    adminTokenDev()
      .then(token =>
        axios.delete(
        `${DEV_EMS_APIS_URL}/elder-subscriptions/${id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`
            }
          }
        )
      )
      .then(res => {
        dispatch(get());
      })
      .catch(err => console.log(err))
      .finally(_ => dispatch({ type: SET_FALSE }));
  };
};

export const reset = () => dispatch => dispatch({ type: RESET_EldSub });
